export var sasBrandColor = {
    midnightBlue: "#032954",
    lightBlue: "#CFDEFD",
    sasBlue: "#0766D1",
    mediumBlue: "#4398F9",
    slate: "#7E889A",
    white: "#FFFFFF",
    black: "#000000"
};
//# sourceMappingURL=brandColors.js.map